import RichText from './RichText';
export default RichText;
